"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../elements/elements/RichText/constants");
const font_1 = require("../../font");
const styleSchema = {};
const fontSchema = Object.assign({}, font_1.FONT_SCHEMA_EMPTY);
exports.default = { [constants_1.TYPE]: { style: {}, font: fontSchema, feedback: {} } };
